import { createAction } from 'redux-actions';
import { PagePrivileges } from '../../types/pagePrivileges';

export const fetchPagePrivilegesSuccess = createAction<PagePrivileges>(
  'PAGE.PRIVILEGES.FETCH.SUCCESS'
);
